(function () {
  'use strict';


  var bar = document.getElementById('havjoy-sticky-checkout');
  if (!bar) return;

  var totalEl = bar.querySelector('.havjoy-sticky-checkout__total');
  var cartItemCount = parseInt(bar.dataset.itemCount || '0', 10);
  var isVisible = false;

  // --- View Cart button: open cart drawer via existing CartDrawerController ---
  var viewCartBtn = bar.querySelector('[data-action="open-cart"]');
  if (viewCartBtn) {
    viewCartBtn.addEventListener('click', function () {
      if (typeof CartDrawerController !== 'undefined') {
        CartDrawerController.open();
      }
    });
  }

  // --- Checkout button: explicit navigation to prevent interference from modals/forms ---
  var checkoutBtn = bar.querySelector('.havjoy-sticky-checkout__btn');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = checkoutBtn.getAttribute('href') || '/checkout';
    });
  }

  // --- Modal detection ---
  // Checks for:
  // 1. body.className containing 'overflow-hidden' (catches class variants like overflow-hidden-mobile, overflow-hidden-tablet)
  // 2. body.style.overflow = 'hidden' (inline style set by havjoy personalize modals)
  // 3. DOM elements with specific modal/drawer selectors
  function isModalOpen() {
    if (document.body.className.indexOf('overflow-hidden') !== -1) return true;
    if (document.body.style.overflow === 'hidden') return true;
    if (document.querySelector(
      '.personalize-modal.active, .modal.active, .drawer.active, ' +
      '.hj-story__modal.active, dialog[open], [data-modal][open]'
    )) return true;
    return false;
  }

  // --- Visibility toggle ---
  // isVisible guard prevents redundant DOM writes on each MutationObserver tick.
  function updateVisibility() {
    var shouldShow = cartItemCount > 0 && !isModalOpen();
    if (shouldShow === isVisible) return;
    isVisible = shouldShow;
    bar.classList.toggle('is-visible', shouldShow);
    bar.setAttribute('aria-hidden', String(!shouldShow));
  }

  // --- Debounce ---
  function debounce(fn, ms) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, ms);
    };
  }

  var debouncedUpdate = debounce(updateVisibility, 30);

  // --- Section re-fetch on cart update ---
  // Uses Shopify Section Rendering API to get fresh Liquid-rendered total.
  // Liquid handles currency/locale formatting — no custom formatter needed.
  function fetchSection() {
    fetch('/cart?sections=havjoy-sticky-checkout')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['havjoy-sticky-checkout'];
        if (!html) return;

        var doc = new DOMParser().parseFromString(html, 'text/html');
        var updated = doc.getElementById('havjoy-sticky-checkout');
        if (!updated) return;

        cartItemCount = parseInt(updated.dataset.itemCount || '0', 10);

        var newTotal = updated.querySelector('.havjoy-sticky-checkout__total');
        if (newTotal && totalEl) {
          totalEl.textContent = newTotal.textContent.trim();
        }

        updateVisibility();
      })
      .catch(function (err) {
        console.error('[havjoy-sticky-checkout] section fetch failed:', err);
      });
  }

  // --- PubSub: listen for cart-update ---
  // subscribe() and PUB_SUB_EVENTS are theme globals from constants.js + pubsub.js (both defer).
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
      if (event && event.source === 'hj-cart') {
        cartItemCount = event.cartData && typeof event.cartData.item_count === 'number'
          ? event.cartData.item_count
          : parseInt(bar.dataset.itemCount || '0', 10);
        bar.dataset.itemCount = String(cartItemCount);
        updateVisibility();
        return;
      }
      fetchSection();
    });
  }

  // --- MutationObserver 1: body class and style changes ---
  // Fires when overflow-hidden is toggled (cart drawer open/close, modal open/close).
  // Also watches style attribute changes (havjoy personalize modals set body.style.overflow).
  new MutationObserver(debouncedUpdate).observe(document.body, {
    attributes: true,
    attributeFilter: ['class', 'style']
  });

  // --- MutationObserver 2: direct children of body added/removed ---
  // Fires when modals are dynamically injected into body.
  new MutationObserver(debouncedUpdate).observe(document.body, {
    childList: true
  });

  // --- Init ---
  // data-item-count is rendered by Liquid — no fetch needed on first load.
  updateVisibility();
})();
